// extracted by mini-css-extract-plugin
export default {"feature-list":"feature-list--g25x4Nsh","featureList":"feature-list--g25x4Nsh"};